<template>
  <div>
    <v-snackbar top class="toast__element" v-model="snackbar" :color="color">
      <template v-if="icon">
        <v-icon class="toast__icon" :size="24">
          {{ icon }}
        </v-icon>
      </template>
      <span class="toast__content">
        {{ text }}
        <a
          v-if="redirectLink"
          :href="redirectLink.linkPath"
          class="toast__content__link"
          target="_blank"
        >
          {{ redirectLink.linkText }}
        </a>
      </span>
      <v-btn class="toast__close" text @click="snackbar = false">
        <template v-if="closeIcon">
          <v-icon :size="16">
            {{ closeIcon }}
          </v-icon>
        </template>
        <template v-else>
          {{ $t("va.close") }}
        </template>
      </v-btn>
    </v-snackbar>
    <confirm></confirm>
  </div>
</template>

<script>
import Confirm from "../internal/Confirm";

/**
 * Internal VaMessages system for snackbar/toaster infos and confirm dialog.
 * Integrated with all resource modules for message API calls.
 * Will automatically show `message` error property in case or API errors.
 * Already included in main admin layout, use it only if you need total custom layout.
 */
export default {
  components: {
    Confirm,
  },
  data() {
    return {
      snackbar: false,
      text: null,
      color: null,
      icon: null,
      closeIcon: null,
      redirectLink: null,
    };
  },
  watch: {
    "$store.state.messages.toast"({color, message, redirectLink}) {
      const toastIcons = this.$admin?.toastIcons;
      const icon = toastIcons[color] ?? null;

      this.redirectLink = redirectLink ?? null;
      this.snackbar = true;
      this.text = message;
      this.color = color;
      this.icon = icon;
      this.closeIcon = this.$admin?.toastIcons?.closeIcon;
    },
  },
};
</script>
<style scoped lang="scss">
.toast__element {
  top: 16px;
  left: 50%;
  z-index: 999;
  -webkit-transform: translateX(-50%);
  transform: translateX(-50%);
  position: fixed;
  transition: transform 0.8s ease-in-out;
}
.menu-open {
  .toast__element {
    @media (min-width: 1264px) {
      transform: translateX(calc(-50% + 130px));
    }
  }
}
</style>
